import { __module as p } from "./index.es273.js";
var V = p.exports, C;
function $() {
  return C ? p.exports : (C = 1, (function(M, X) {
    (function(k, d) {
      M.exports = d();
    })(V, (function() {
      var k = "rgba(100, 100, 100, 0.7)", d = "rgba(255, 255, 255, 0.8)", b = "round", a = function(i, t) {
        if (!(i instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }, h = /* @__PURE__ */ (function() {
        function i(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }
        return function(t, e, n) {
          return e && i(t.prototype, e), n && i(t, n), t;
        };
      })(), q = Object.assign || function(i) {
        for (var t = 1; t < arguments.length; t++) {
          var e = arguments[t];
          for (var n in e)
            Object.prototype.hasOwnProperty.call(e, n) && (i[n] = e[n]);
        }
        return i;
      }, u = function(i, t) {
        if (typeof t != "function" && t !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        i.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: i,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(i, t) : i.__proto__ = t);
      }, c = function(i, t) {
        if (!i)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t && (typeof t == "object" || typeof t == "function") ? t : i;
      }, l = (function() {
        function i() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20, e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : k, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : d;
          return a(this, i), this._canvas = document.createElement("canvas"), this._context = this._canvas.getContext("2d"), this._canvas.width = t, this._canvas.height = t, this._context.fillStyle = e, this._context.fillRect(0, 0, this._canvas.width, this._canvas.height), this._size = t, this._patternColor = n, this;
        }
        return h(i, [{
          key: "setStrokeProps",
          value: function() {
            this._context.strokeStyle = this._patternColor, this._context.lineWidth = this._size / 10, this._context.lineJoin = b, this._context.lineCap = b;
          }
        }, {
          key: "setFillProps",
          value: function() {
            this._context.fillStyle = this._patternColor;
          }
        }]), i;
      })(), E = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawPlus(), this.drawPlus(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawPlus",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = r / 4;
            this._context.moveTo(s + e, 0 + n), this._context.lineTo(s + e, o + n), this._context.moveTo(0 + e, s + n), this._context.lineTo(o + e, s + n), this._context.closePath();
          }
        }]), t;
      })(l), O = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawCross(), this.drawCross(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawCross",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = 2;
            this._context.moveTo(e + s, n + s), this._context.lineTo(o - s + e, o - s + n), this._context.moveTo(e + s, o - s + n), this._context.lineTo(o - s + e, n + s), this._context.closePath();
          }
        }]), t;
      })(l), m = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawDash(), this.drawDash(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawDash",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = 2;
            this._context.moveTo(e + s, n + s), this._context.lineTo(o - s + e, o - s + n), this._context.closePath();
          }
        }]), t;
      })(l), F = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            this._context.beginPath(), this.setStrokeProps();
            var n = new O();
            n.drawCross.call(this);
            var r = new m();
            return r.drawDash.call(this, e, e), this._context.stroke(), this._canvas;
          }
        }]), t;
      })(l), g = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setFillProps(), this.drawDot(), this.drawDot(e, e), this._context.fill(), this._canvas;
          }
        }, {
          key: "drawDot",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this._size / 10, o = this._size, s = o / 4, v = s + e, f = s + n;
            this._context.moveTo(v + s, f), this._context.arc(v, f, r, 0, 2 * Math.PI), this._context.closePath();
          }
        }]), t;
      })(l), L = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            this._context.beginPath(), this.setStrokeProps();
            var n = new m();
            n.drawDash.call(this, e, e), this._context.closePath(), this._context.stroke(), this.setFillProps();
            var r = new g();
            return r.drawDot.call(this), this._context.fill(), this._canvas;
          }
        }]), t;
      })(l), I = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2, n = this._size / 5;
            return this._context.beginPath(), this.setFillProps(), this.drawDot(0, 0, n), this.drawDot(e, e, n), this._context.fill(), this._canvas;
          }
        }]), t;
      })(g), R = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2, n = this._size / 5;
            return this._context.beginPath(), this.setStrokeProps(), this.drawDot(0, 0, n), this.drawDot(e, e, n), this._context.stroke(), this._canvas;
          }
        }]), t;
      })(g), x = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawLine(), this.drawLine(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawLine",
          value: function() {
            var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = this._size, r = n / 4;
            this._context.moveTo(0, r + e), this._context.lineTo(this._size, r + e), this._context.closePath();
          }
        }]), t;
      })(l), B = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            return this._context.translate(this._size, 0), this._context.rotate(90 * Math.PI / 180), x.prototype.drawTile.call(this), this._canvas;
          }
        }]), t;
      })(x), W = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            return this._context.beginPath(), this.setStrokeProps(), this.drawWeave(0, 0), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawWeave",
          value: function(e, n) {
            var r = this._size, o = r / 2;
            this._context.moveTo(e + 1, n + 1), this._context.lineTo(o - 1, o - 1), this._context.moveTo(o + 1, r - 1), this._context.lineTo(r - 1, o + 1), this._context.closePath();
          }
        }]), t;
      })(l), y = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            return this._context.beginPath(), this.setStrokeProps(), this.drawZigzag(), this.drawZigzag(this._size / 2), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawZigzag",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = this._size, r = n / 4, o = n / 2, s = n / 10;
            this._context.moveTo(0, s + e), this._context.lineTo(r, o - s + e), this._context.lineTo(o, s + e), this._context.lineTo(n - r, o - s + e), this._context.lineTo(n, s + e);
          }
        }]), t;
      })(l), Z = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            return this._context.translate(this._size, 0), this._context.rotate(90 * Math.PI / 180), y.prototype.drawTile.call(this), this._canvas;
          }
        }]), t;
      })(y), w = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawDiagonalLine(), this.drawDiagonalLine(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawDiagonalLine",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = 1;
            this._context.moveTo(o - s - e, s * -1 + n), this._context.lineTo(r + 1 - e, o + 1 + n), this._context.closePath();
          }
        }]), t;
      })(l), J = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            return this._context.translate(this._size, 0), this._context.rotate(90 * Math.PI / 180), w.prototype.drawTile.call(this), this._canvas;
          }
        }]), t;
      })(w), A = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setFillProps(), this.drawSquare(), this.drawSquare(e, e), this._context.fill(), this._canvas;
          }
        }, {
          key: "drawSquare",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = r / 20;
            this._context.fillRect(e + s, n + s, o - s * 2, o - s * 2), this._context.closePath();
          }
        }]), t;
      })(l), G = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawBox(), this.drawBox(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawBox",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = r / 20;
            this._context.strokeRect(e + s, n + s, o - s * 4, o - s * 4), this._context.closePath();
          }
        }]), t;
      })(l), P = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setFillProps(), this.drawTriangle(), this.drawTriangle(e, e), this._context.fill(), this._canvas;
          }
        }, {
          key: "drawTriangle",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = r / 4;
            this._context.moveTo(s + e, n), this._context.lineTo(o + e, o + n), this._context.lineTo(e, o + n), this._context.closePath();
          }
        }]), t;
      })(l), H = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size;
            return this._context.translate(e, e), this._context.rotate(180 * Math.PI / 180), P.prototype.drawTile.call(this), this._canvas;
          }
        }]), t;
      })(P), z = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setFillProps(), this.drawDiamond(), this.drawDiamond(e, e), this._context.fill(), this._canvas;
          }
        }, {
          key: "drawDiamond",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2, s = r / 4;
            this._context.moveTo(s + e, n), this._context.lineTo(o + e, s + n), this._context.lineTo(s + e, o + n), this._context.lineTo(e, s + n), this._context.closePath();
          }
        }]), t;
      })(l), K = (function(i) {
        u(t, i);
        function t() {
          return a(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return h(t, [{
          key: "drawTile",
          value: function() {
            var e = this._size / 2;
            return this._context.beginPath(), this.setStrokeProps(), this.drawDiamond(), this.drawDiamond(e, e), this._context.stroke(), this._canvas;
          }
        }, {
          key: "drawDiamond",
          value: function() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = this._size, o = r / 2 - 1, s = r / 4;
            this._context.moveTo(s + e, n + 1), this._context.lineTo(o + e, s + n), this._context.lineTo(s + e, o + n), this._context.lineTo(e + 1, s + n), this._context.closePath();
          }
        }]), t;
      })(z), _ = {
        plus: E,
        cross: O,
        dash: m,
        "cross-dash": F,
        dot: g,
        "dot-dash": L,
        disc: I,
        ring: R,
        line: x,
        "line-vertical": B,
        weave: W,
        zigzag: y,
        "zigzag-vertical": Z,
        diagonal: w,
        "diagonal-right-left": J,
        square: A,
        box: G,
        triangle: P,
        "triangle-inverted": H,
        diamond: z,
        "diamond-box": K
      }, N = {
        circle: _.disc,
        "triangle-vertical": _["triangle-inverted"],
        "line-horizontal": _.line,
        "line-diagonal-lr": _.diagonal,
        "line-diagonal-rl": _["diagonal-right-left"],
        "zigzag-horizontal": _.zigzag,
        "diamond-outline": _["diamond-box"]
      }, j = [];
      function T() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = Object.keys(_);
        i.forEach(function(n) {
          t.splice(t.indexOf(n), 1);
        });
        var e = Math.floor(Math.random() * t.length);
        return t[e];
      }
      q(j, _, N);
      function D() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "square", t = arguments[1], e = arguments[2], n = arguments[3], r = document.createElement("canvas"), o = r.getContext("2d"), s = n * 2, v = j[i], f = new v(n, t, e), S = o.createPattern(f.drawTile(), "repeat");
        return r.width = s, r.height = s, S.shapeType = i, S;
      }
      function Q(i) {
        var t = void 0, e = void 0;
        return i.map(function(n, r, o) {
          var s = void 0;
          return r === 0 ? (s = T(), e = s, t = e) : r === o.length - 1 ? s = T([e, t]) : (s = T([e]), e = s), D(s, n);
        });
      }
      var U = {
        draw: D,
        generate: Q
      };
      return U;
    }));
  })(p), p.exports);
}
export {
  $ as __require
};
//# sourceMappingURL=index.es168.js.map
